<!--
 * @Author: your name
 * @Date: 2022-01-10 11:16:37
 * @LastEditTime: 2022-04-18 15:44:26
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \cacaclo_front_end\src\views\order\list\Index.vue
-->
<template>
  <div class="main">
    <div v-if="isPC">
      <div class="topTitle">{{$t('orderList.AllOrder')}}</div>
      <div class="bg-white">
        <el-tabs v-model="activeName" @tab-click="handleClick" class="myTabs" v-if="!emptyAllData">
          <el-tab-pane :label="$t('orderList.AllOrder')" name="all_order">
              <!-- <AllStatus orderStatus="all_order" ref="all_order" @FulfillOrder="FulfillOrderClick"></AllStatus> -->
          </el-tab-pane>
          <el-tab-pane :label="$t('Order.List.Index.WaitingPayment')" name="waiting_payment">
              <!-- <AllStatus orderStatus="waiting_payment" ref="waiting_payment" @FulfillOrder="FulfillOrderClick"></AllStatus> -->
          </el-tab-pane>
          <el-tab-pane :label="$t('Order.List.Index.WaitingToShip')" name="waiting_to_ship">
            <!-- <AllStatus orderStatus="waiting_to_ship" ref="waiting_to_ship" @FulfillOrder="FulfillOrderClick"></AllStatus> -->
          </el-tab-pane>
          <el-tab-pane :label="$t('Order.List.Index.InTransit')" name="in_transit">
              <!-- <AllStatus orderStatus="in_transit" ref="in_transit" @FulfillOrder="FulfillOrderClick"></AllStatus> -->
          </el-tab-pane>
          <el-tab-pane :label="$t('Order.List.Index.RefundReturn')" name="Refund&Return">
              <!-- <AllStatus orderStatus="Refund&Return" ref="Refund&Return" @FulfillOrder="FulfillOrderClick"></AllStatus> -->
          </el-tab-pane>
          <el-tab-pane :label="$t('Order.List.Index.OrderInfoMissing')" name="order_info_missing">
            <!-- <AllStatus orderStatus="order_info_missing" ref="order_info_missing" @FulfillOrder="FulfillOrderClick"></AllStatus> -->
          </el-tab-pane>
        </el-tabs>
        <div v-if="!emptyAllData">
          <AllStatus v-if="activeName === 'all_order'" orderStatus="all_order" ref="all_order" @FulfillOrder="FulfillOrderClick"></AllStatus>
          <AllStatus v-if="activeName === 'waiting_payment'" orderStatus="waiting_payment" ref="waiting_payment" @FulfillOrder="FulfillOrderClick"></AllStatus>
          <AllStatus v-if="activeName === 'waiting_to_ship'" orderStatus="waiting_to_ship" ref="waiting_to_ship" @FulfillOrder="FulfillOrderClick"></AllStatus>
          <AllStatus v-if="activeName === 'in_transit'" orderStatus="in_transit" ref="in_transit" @FulfillOrder="FulfillOrderClick"></AllStatus>
          <AllStatus v-if="activeName === 'Refund&Return'" orderStatus="Refund&Return" ref="Refund&Return" @FulfillOrder="FulfillOrderClick"></AllStatus>
          <AllStatus v-if="activeName === 'order_info_missing'" orderStatus="order_info_missing" ref="order_info_missing" @FulfillOrder="FulfillOrderClick"></AllStatus>
        </div>
        <emptyNoStore v-else :isHaveStore="isHaveStore"></emptyNoStore>
      </div>
      <FulfillOrderDialog ref="FulfillOrderDialog" @submitDone="submitDone"></FulfillOrderDialog>
    </div>
    <mobileVue v-else></mobileVue>
    <payDialog ref="payDialog" @closeDialog="closeDialog"></payDialog>
  </div>
</template>

<script>
import { statusAction } from './data'
import AllStatus from './components/AllStatus'
import payDialog from './components/payDialog.vue'
import FulfillOrderDialog from './components/FulfillOrderDialog.vue'
import emptyNoStore from './components/emptyNoStore.vue'
import API from '@/api'
import mobileVue from './components/mobile.vue'

export default {
  components: {
    AllStatus, payDialog, FulfillOrderDialog, emptyNoStore,
    mobileVue
  },
  data() {
    return {
      activeName: 'all_order',
      statusAction,
      emptyAllData: false,
      isHaveStore: true
    }
  },
  mounted() {
    if (this.isPC) {
      this.isHaveStoreCheck()
      this.$refs[this.activeName].getList().then(res => {
        const { activeName, total } = res
        if (total === undefined) return
        if (activeName === 'all_order' && total === 0) {
          this.emptyAllData = true
        }
      })
    }
    this.$store.dispatch('common/getAddressList')
  },
  methods: {
    handleClick(value) {
      this.$nextTick(() => {
        this.$refs[value.name].getList('clear')
        if (value.name === 'WaitingPayment') {
          this.$refs[value.name].getUserInfo()
        }
      })
    },
    FulfillOrderClick(item) {
      this.$refs.FulfillOrderDialog.show(item)
    },
    // 标记订单提交完成
    submitDone() {
      this.$refs[this.activeName].getList()
    },
    async isHaveStoreCheck() {
      const res = await API.getStoreList()
      this.isHaveStore = !res.data.length
    },
    MTShowPaySelect(row) {
      this.$refs.payDialog.MTShow(row)
    },
    closeDialog() {
      this.$refs[this.activeName].getList()
    }
  }
}
</script>

<style scoped lang="scss">
.myTabs {
  /deep/.el-tabs__nav-scroll {
    margin-left: 40px;
  }
}
.topTitle {
  height: 60px;
  line-height: 60px;
  font-size: 20px;
  font-weight: 600;
}
/deep/.van-tab {
  padding: 0 .2rem;
}
/deep/.van-tabs__nav {
  /deep/.van-tab:last-of-type {
    display: none;
  }
}
/deep/.van-tabs__nav >.van-tab:last-of-type {
  display: none;
}
.waitingToShipFiltersBox {
  .waitingToShipFilters {
  font-size: 14px;
  padding: 10px 28px;
  >div{
    padding: 2px;
    margin-right: 20px;
  }
  .actived{
    background-color: rgba(153, 196, 28, 0.2);
    color: #99C41C;
  }
}
}
.mt_status_selected {
  height: 38px;
  border: 1px solid #E0E0E0;
  font-size: 14px;
  line-height: 36px;
  text-align: center;
  margin: 0 12px 12px;
}
</style>
<style lang="scss">
.MT_orderList_vanTab {
  .van-tabs__nav >.van-tab:nth-of-type(6) {
    display: none !important;
  }
}
</style>
